import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Testimonials.css';
import user1 from '../assets/img/user1.png';
import user2 from '../assets/img/user2.png';
import user3 from '../assets/img/user3.png';

const Testimonials = () => {
  const testimonialsData = [
    {
      image: user1,
      name: 'Dr. R Chidambaram M.D',
      text: 'This method helps identify abnormal regions and assess the extent of pathology by mapping changes in heat patterns. Its a simple, complementary screening technique for imaging modalities. It allows further investigation into the diseases extent and activity. Over six years, we ve studied over 5,000 cases in various camps, covering areas like breast, uterine cervix, thyroid, dental issues, testis, sports injuries, orthopedic and trauma cases, spinal regions, varicose veins, diabetic foot, hemiplegia (pre/post-physiotherapy), and conditions like sinusitis, tonsillitis, adenoids, mastoiditis, ophthalmic issues, dermatological conditions, and pain syndromes.',
      rating: 5,
    },
    {
      image: user2,
      name: 'Dr. Lalesh G.Nahata',
      text: 'This method detects abnormal regions and assesses pathology by mapping heat pattern changes. It’s a simple, complementary screening tool for imaging, helping investigate the diseases extent and activity. Over six years, weve studied 5,000+ cases in areas like breast, thyroid, dental issues, sports injuries, varicose veins, diabetic foot, hemiplegia, and more.',
      rating: 4,
    },
    {
      image: user3,
      name: 'Dr. Annamalai Murugesan',
      text: 'I recommend Infrared for early cancer detection as it can detect breast lesions 5-7 years before mammography, is non-invasive, painless, and radiation-free. Its cost-effective with no side effects and is also useful in diagnosing diabetic ulcers, varicose veins, and thyroid issues.',
      rating: 5,
    },
  ];


  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={i < rating ? 'text-warning' : 'text-secondary'}>&#9733;</span>
    ));
  };

  return (
    <section className="testimonials-section container-fluid">
      <div className="row">
        {/* Left Section */}
        <div className="col-lg-6 p-5">
          {/* <h4 className="section-title">Testimonial</h4> */}
          <h2 className="main-title">What Our <span>Customers Says</span></h2>
          <div class="thermal-line"></div>
          <p className="section-text p-3">
            Our clients appreciate our hassle-free experience, praising the quick and seamless service. They value
            our reliable support.
          </p>
          {/* <button className="btn gradient-btn">Read More ➜</button> */}
        </div>

        {/* Right Section - Testimonials */}
        <div className="col-lg-6 d-flex flex-column align-items-center">
          {testimonialsData.map((testimonial, index) => (
            <div
              key={index}
              className={`testimonial-card d-flex align-items-center ${index === 1 ? 'left-margin' : ''}`}
            >
              <img src={testimonial.image} alt={testimonial.name} className="testimonial-img" />
              <div className="testimonial-content">
                <h5>{testimonial.name}</h5>
                <p>{testimonial.text}</p>
                <div>{renderStars(testimonial.rating)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
